/**
 * The ORDER a refill Save writes in (app#293).
 *
 * ⚠⚠ IT IS A UTILITY BECAUSE THE ORDER IS THE WHOLE FIX AND NOTHING ELSE COULD TEST IT. The panel
 * and the store have no tests in this repository; the rule that matters — *no awaited round trip
 * sits between the two writes* — lived in `CreditBlock.onSave` and `useBilling.setSpendCap`
 * together, where a reader had to hold both open to see it and no assertion could reach it.
 *
 * ⚠⚠ WHY THE ORDER MATTERS, AND IT IS THE ROUTER'S CLOCK. `set_spend_cap` starts a ~2 s settle
 * (`billing.nudgeSettle`) after which the router decides whether to buy, and that margin exists
 * for exactly ONE case: an Owner who raises the monthly maximum AND the refill amount in one
 * Save. The panel writes the cap first, so everything awaited between the two writes is spent out
 * of that margin. It used to be three round trips — the cap write's response, `get()`, and
 * `loadCredit()` — and at a ~700 ms RTT the rule write committed at about `t0+2.1 s` while the
 * nudge had already decided at `t0+2.0 s`. It then read the OLD rule, bought the OLD amount, and
 * left the balance above the trigger, so the amount the Owner had just raised never fired that
 * period. That is test-plan case D-26 failing on the exact case the settle was written for.
 *
 * ⚠ app PR #292 removed one of the three by running the two reads together. This removes the
 * other two by moving them AFTER both writes — it takes the race out rather than budgeting for
 * it, and it spends no router constant on a browser's latency.
 *
 * ⚠ `reread` still runs, and it has to: the reads are what keep the gauge and the cap field
 * agreeing about how much of the budget is left. They are late now, not gone.
 */
export type RefillSaveSteps = {
  /** The cap write, when the cap changed. Omitted when it did not. */
  writeCap?: () => Promise<void>
  /** The rule write, when the pair changed. Omitted when it did not. */
  writeRule?: () => Promise<void>
  /** Everything that reads state back, run ONCE, after both writes. */
  reread: () => Promise<void>
}

export const saveRefillSettings = async (steps: RefillSaveSteps): Promise<void> => {
  if (steps.writeCap) await steps.writeCap()
  if (steps.writeRule) await steps.writeRule()
  await steps.reread()
}
